import axois, { AxiosInstance } from "axios";
import LocalDb from "src/services/db";
import { BaseApiService } from "./api-base";
import { WfApiService } from "./wf";
import { WfAuthApiService } from "./wf-auth";
import { CfAuthApiService } from "./cf-auth";
import { DsApiService } from "./ds";
import { SqlrApiService } from "./sqlr";
import { SqlrDatasetApiService } from "./sqlr-dataset/sqlr-dataset";
import { SqlrEventsApiService } from "./sqlr-events/sqlr-events";
import { TdlApiService } from "./tdl/tdl";
import { OmaApiService } from "./oma";
import { CfApiService } from "./cf/cf";
import { TtsApiService } from "./tts";
import { SttApiService } from "./stt";
import { GjrApiService } from "./gjr";
import { GmcApiService } from "./gmc";
import { OracleApiService } from "./oracle";
import { GoalifyApiService } from "./goalify";
import { MinioApiService } from "./s3/minio";
import { ToExcelApiService } from "./toexcel/toexcel";
import { Iev4sApiService } from "src/services/api/iev4s";
import { FuncApiService } from "src/services/api/fnc";

class ApiService extends BaseApiService {
  host = "";
  http: AxiosInstance;
  services: string[] = [];

  wf!: WfApiService;
  wfAuth!: WfAuthApiService;
  cfAuth!: CfAuthApiService;
  ds!: DsApiService;
  sqlr!: SqlrApiService;
  sqlrDataset!: SqlrDatasetApiService;
  sqlrEvents!: SqlrEventsApiService;
  tdl!: TdlApiService;
  toExcel!: ToExcelApiService;
  oma!: OmaApiService;
  cf!: CfApiService;
  tts!: TtsApiService;
  stt!: SttApiService;
  gjr!: GjrApiService;
  gmc!: GmcApiService;
  minio!: MinioApiService;
  idom!: OracleApiService;
  goalify!: GoalifyApiService;
  iev4s!: Iev4sApiService;
  fnc!: FuncApiService;

  cache_api_list: string[] = ["api/init"];

  constructor() {
    super("");
    this.http = axois.create({
      baseURL: this.host,
    });
    //#region кэшируем ответы API и возвращаем их в случае ошибки запроса
    this.http.interceptors.response.use(
      (response) => {
        const url = response.config.url ?? "";
        if (this.cache_api_list.indexOf(url) > -1) {
          LocalDb.then((db) => db.cache_api.put(url, response.data));
        }
        return response;
      },
      async (error) => {
        // error.request | error.response | error.message
        let cache_response = undefined;
        const url = error.response.config.url;
        if (this.cache_api_list.indexOf(url) > -1) {
          const db = await LocalDb;
          cache_response = await db.cache_api.getByKey(url);
        }
        if (cache_response) {
          error.response.status = 200;
          error.response.data = cache_response;
          return Promise.resolve(error.response);
        } else {
          return Promise.reject(error);
        }
      },
    );
    //#endregion
  }

  init() {
    this.host = this.settings.backend;
    this.wfAuth = new WfAuthApiService(this.host);

    if (this.services.includes("wf")) {
      this.wf = new WfApiService(this.host);
    }
    if (this.services.includes("cf")) {
      this.cfAuth = new CfAuthApiService(this.host);
    }
    if (this.services.includes("ds")) {
      this.ds = new DsApiService(this.host);
    }
    if (this.services.includes("sqlr")) {
      this.sqlr = new SqlrApiService(this.host);
    }
    if (this.services.includes("sqlr_dataset")) {
      this.sqlrDataset = new SqlrDatasetApiService(this.host);
    }
    if (this.services.includes("sqlr")) {
      this.sqlrEvents = new SqlrEventsApiService(this.host);
    }
    if (this.services.includes("tdl")) {
      this.tdl = new TdlApiService(this.host);
    }
    if (this.services.includes("toexcel")) {
      this.toExcel = new ToExcelApiService(this.host);
    }
    if (this.services.includes("oma")) {
      this.oma = new OmaApiService(this.host);
    }
    if (this.services.includes("cf")) {
      this.cf = new CfApiService(this.host);
    }
    if (this.services.includes("tts")) {
      this.tts = new TtsApiService(this.host);
    }
    if (this.services.includes("stt")) {
      this.stt = new SttApiService(this.host);
    }
    if (this.services.includes("gjr")) {
      this.gjr = new GjrApiService(this.host);
    }
    if (this.services.includes("gmc")) {
      this.gmc = new GmcApiService(this.host);
    }
    if (this.services.includes("minio")) {
      this.minio = new MinioApiService();
    }
    if (this.services.includes("tlgrm")) {
      this.idom = new OracleApiService(this.host);
    }
    if (this.services.includes("goalify")) {
      this.goalify = new GoalifyApiService(this.host);
    }
    this.iev4s = new Iev4sApiService(this.host);
    this.fnc = new FuncApiService(this.host);
    // console.log("API inited", this.services);
  }

  getInitData(app_ref = undefined) {
    this.services = ["client", "ws", "stt", "tts", "minio", "cf", "pws"];
    const isAnonymous = (window as any).$store.getters["user/isAnonymous"];
    if (!isAnonymous) {
      this.services.push(
        ...[
          "ma",
          "oma",
          "sqlr",
          "sqlr_dataset",
          "gjr",
          "gmc",
          "cube",
          "ds",
          "wf",
          "tdl",
          "toexcel",
          "cube2csv",
          "tlgrm",
          "goalify",
        ],
      );
    }

    const body = {
      app_ref,
      v: "2",
      services: this.services,
      is_debug: true,
    };
    return this.http.post("api/init", body).then((response) => response.data);
  }
}

export default new ApiService();
